import ShareholderLocationField from './ShareholderLocationField';
import ShareholderLocationFieldValidation from './validation';

export {
    ShareholderLocationFieldValidation
};

export default ShareholderLocationField;
